function getRouteForNotificationLink (notificationType) {
  switch (notificationType) {
    case 'vacation':
    case 'dayOff': return 'vacations'
    case 'birthday': return 'birthday'
    case 'candidate_meeting': return 'candidates'
    case 'hr_meeting': return 'meetings'
    default:
      break;
  }
}
export default getRouteForNotificationLink
